var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"layout-web"},[_c('top-bar',{attrs:{"id":"Head"}}),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }